import { cloneElement } from 'react';
import { useIsMobile } from '../../../../../utils/getIsMobile';
import { Tooltip } from '../../../../feedback/Tooltip';
import { IconHelp } from '../../../../icon/IconHelp';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { BusinessStatisticSectionFlex } from './styles';
import { BusinessStatisticSectionProps } from './types';

export const BusinessStatisticSection = (props: BusinessStatisticSectionProps) => {
    const { title, statsSlot, helpMessage, ...other } = props;
    const isMobile = useIsMobile();

    return (
        <BusinessStatisticSectionFlex
            width={{ xs: '100%', sm: '50%' }}
            p={2}
            isMobile={isMobile}
            {...other}
        >
            <Flex direction="row" spacing={0.5} alignItems="center">
                <Typography variant="title3" weight="bold">
                    {title}
                </Typography>
                <Tooltip
                    trigger={<IconHelp color="var(--color-primary)" cursor="help" size={16} />}
                >
                    {cloneElement(helpMessage)}
                </Tooltip>
            </Flex>
            <Flex width="100%" direction="row" flexWrap="wrap">
                {cloneElement(statsSlot)}
            </Flex>
        </BusinessStatisticSectionFlex>
    );
};
